import React from 'react';
import { Image } from 'react-bootstrap';

import loaderGif from '../images/loader.gif'

const Loading = () => (
  <div className="AppLoader">
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <Image src={loaderGif} />
    </div>
  </div>
);

export default Loading;